import { Model } from '@models/model';
import { Paginated } from '@models/paginated';

export class SubaccountStatistics extends Model {
  idSubaccountUser: number;
  login: string;
  name?: string;
  surname?: string;
  companyName?: string;
  totalsSMSStatistics?: TotalsSMSStatistics;
}

export class ListSubaccountStatistics extends Paginated {
  data: Array<SubaccountStatistics>;
}

export class TotalsSMSStatistics extends Model {
  totals: number;
  detailsSmsStatistics?: Array<DetailsSmsStatistics>;
}

export class DetailsSmsStatistics extends Model {
  idMessageType: string;
  total: number;
}
